export default "__VITE_ASSET__cc10b3f7__"